/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_CanceledInputs */

const zh_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已取消`)
};

const en_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canceled`)
};

const es_status_canceled = /** @type {(inputs: Status_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelado`)
};

/**
* | output |
* | --- |
* | "Canceled" |
*
* @param {Status_CanceledInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_canceled = /** @type {((inputs?: Status_CanceledInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_CanceledInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_status_canceled(inputs)
	if (locale === "en") return en_status_canceled(inputs)
	return es_status_canceled(inputs)
});